import { useContext } from 'react';
import { Socket } from 'socket.io-client';

import { SocketContext } from '../contexts';
import { UseSocket } from '../interfaces';

export const useSocket: () => UseSocket = (): UseSocket => {
  const socket: Socket | undefined = useContext(SocketContext);

  return { socket };
};
